import { useFormContext } from 'react-hook-form';
import { FormControl, FormErrorMessage } from '@chakra-ui/react';

import { ERROR_MESSAGE_CLASSNAME } from 'components/_core/form';
import { InvoiceFormSchema } from 'features/Work/form/invoiceForm.schema';

import locales from '../locales';

export const Errors = () => {
  const { watch } = useFormContext<InvoiceFormSchema>();

  const allowCreditCardPayment = watch('allowCreditCardPayment');
  const allowIbanPayment = watch('allowIbanPayment');

  const showError = !(allowCreditCardPayment || allowIbanPayment);

  return (
    <FormControl isInvalid={showError}>
      {showError ? (
        <FormErrorMessage className={ERROR_MESSAGE_CLASSNAME}>
          {locales.selectOneError}
        </FormErrorMessage>
      ) : null}
    </FormControl>
  );
};
